<template>
  <div style="margin-top: 10px;">
    <b-tabs
      v-model="tabIndex"
      @input="handleTabChanged"
    >
      <b-tab>
        <template #title>
          <strong style="font-weight: 500; color: black">{{ $t("StoreToStore") }}</strong>
        </template>
        <OrderMovementsList ref="orderMovementsList" />
      </b-tab>
      <b-tab>
        <template #title>
          <strong style="font-weight: 500; color: black">{{ $t("InternalMovementInsideStore") }}</strong>
        </template>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import OrderMovementsList from '@/components/InternalMovement/OrderMovementsList.vue'

export default {
  components: {
    OrderMovementsList,
  },
  data() {
    return {
      tabIndex: 0,
    }
  },
  methods: {
    handleTabChanged(newTabIndex) {
      if (newTabIndex === 0) {
        this.$refs.orderMovementsList.updateOrderMovementsList();
      }
    },
    updateOrderMovements() {
      if (this.tabIndex === 0) {
        this.$refs.orderMovementsList.updateOrderMovementsList();
      }
    },
  },
}
</script>

<style scoped>

</style>
